import { createContext, useContext } from 'react'

export const DialogContext = createContext<{
  onClose: (event?: unknown, reason?: 'backdropClick' | 'escapeKeyDown') => void
}>({ onClose: () => null })

export const useCloseHandler = () => useContext(DialogContext).onClose
